import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/nav.scss";
import NavPhone from "./NavPhone";
import NavScreen from "./NavScreen";

const w = window;

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileNav: false,
    };

    this.handleSelection = this.handleSelection.bind(this);
    this.navButtons = this.navButtons.bind(this);
  }

  handleSelection(i, f) {
    this.props.handleSelection(this.navButtons()[i], f);
  }

  navButtons() {
    const algorithm = require("./thumb/Algorithm.png");
    const plus = require("./thumb/Plus.png");
    const clipboard = require("./thumb/Clipboard.png");
    const document = require("./thumb/Document.png");
    const globe = require("./thumb/Globe.png");
    const books = require("./thumb/Books.png");
    const organizations = require("./thumb/Organizations.png");

    return [
      {
        ref: "management",
        control: "nav-home",
        label: "Management",
        card: "",
        color: "#040040",
        buttonImage: algorithm,
        tabImage: clipboard,
      },
      {
        ref: "tools",
        control: "nav-contact",
        label: "Clinical Tools",
        card: "",
        color: "#1A31CA",
        buttonImage: plus,
        tabImage: plus,
      },
      {
        ref: "resources",
        control: "nav-contact",
        label: "Resources",
        card: "rescard",
        color: "#180F36",
        buttonImage: globe,
        tabImage: books,
      },
      {
        ref: "organizations",
        control: "nav-contact",
        label: "Organizations",
        card: "rescard",
        color: "#E35522",
        buttonImage: globe,
        tabImage: organizations,
      },
    ];
  }

  componentDidMount() {
    w.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    this.setState({ mobileNav: w.innerWidth <= 801 });
  }

  render() {
    return this.state.mobileNav ? (
      <NavPhone
        handleSelection={this.handleSelection}
        navButtons={this.navButtons()}
      />
    ) : (
      <NavScreen
        handleSelection={this.handleSelection}
        navButtons={this.navButtons()}
      />
    );
  }
}

export default NavBar;
